import { makeAutoObservable } from 'mobx';
import apolloClient from 'api/apolloClient';
import { GET_BROWSING_PORTFOLIO_CONFIG_FORM, GET_FORM_BY_ID } from 'api/formService';
import { ApolloQueryResult } from '@apollo/client';
import { FormObjectFromJSON } from '@insurancemenu/imenu-components-lib/dist/types';
import { BrowsingInfo } from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';

export const INITIAL_FORM_OBJECT: Readonly<FormObjectFromJSON> = Object.freeze({
  id: '',
  formTitle: '',
  sections: [],
  description: '',
});

export type FormBcByProductLine = {
  [key in ProductLineId]?: BrowsingInfo[];
};

export class FormStore {
  // eslint-disable-next-line class-methods-use-this
  async cachedRequestFormById(
    id: string,
    bc?: FormBcByProductLine,
  ): Promise<ApolloQueryResult<{ getFormById: FormObjectFromJSON }>> {
    return apolloClient.query<{ getFormById: FormObjectFromJSON }>({
      query: GET_FORM_BY_ID,
      variables: { id, bc },
    });
  }

  // eslint-disable-next-line class-methods-use-this
  async requestPortfolioConfigForm(
    portfolioId: string,
    effectiveDate: string,
  ): Promise<ApolloQueryResult<{ getBrowsingConfigFormByPortfolioId: FormObjectFromJSON[] }>> {
    return apolloClient.query<{ getBrowsingConfigFormByPortfolioId: FormObjectFromJSON[] }>({
      query: GET_BROWSING_PORTFOLIO_CONFIG_FORM,
      fetchPolicy: 'no-cache',
      variables: { portfolioId, effectiveDate },
    });
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
